import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81105266"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Project", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bouwnummer", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gepubliceerd", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Gelezen", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import { generalStore } from '@/stores/general'
import axios from 'axios'
import { notification } from 'ant-design-vue'
import MessageAddCommentCard from '@/components/message/MessageAddCommentCard.vue'
import MessageCommentsCard from '@/components/message/MessageCommentsCard.vue'
import MessageFilelist from '@/components/message/MessageFilelist.vue'

interface MessageType {
  id: number
  title: string
  body: string
  can_respond: boolean
  project: { id:number, name:string, reference:string }|null
  building: { id:number, number:number}|null
  comments: { id:number, body:string, user: { full_name:string }, ago:string, media: { id:number, file_name:string, url:string, mime_type: string }[] }[]
  created_ago: string
  created_at: string
  read_ago: string
  read_at: string
  media: { id:number, file_name:string, url:string, mime_type: string }[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageDetails',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const message = ref<MessageType|null>(null)

onMounted(() => {
  getMessage()
})

function getMessage () : void {
  axios.get(process.env.VUE_APP_API_URL_V2 + '/messages/' + route.params.messageId).then((r) => {
    message.value = r.data.data
    markAsRead()
  }).catch((e) => {
    if (e.response.status === 403) {
      router.push({ name: 'Dashboard' })
      notification.warning({ message: 'Toegang geweigerd.', description: 'U heeft geen toegang tot deze pagina.', duration: 5 })
    } else {
      router.push({ name: 'Dashboard' })
      notification.error({ message: 'Fout tijdens ophalen van bericht.', description: 'Er is iets mis gegaan. Probeer het later nog een keer.', duration: 5 })
    }
  })
}

function markAsRead () {
  axios.post(process.env.VUE_APP_API_URL_V2 + '/messages/' + route.params.messageId + '/read')
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: [16,16] }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, {
        xs: 24,
        lg: 18
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, {
            gutter: [16,16],
            class: "no-mb"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_card, {
                    loading: !message.value
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(message.value ? message.value.title : 'Aan het laden..'), 1)
                    ]),
                    extra: _withCtx(() => [
                      (_unref(generalStore)().desktop)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'Dashboard' })))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Terug naar dashboard")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "message-content",
                        innerHTML: message.value?.body
                      }, null, 8, _hoisted_1)
                    ]),
                    _: 1
                  }, 8, ["loading"])
                ]),
                _: 1
              }),
              (message.value && message.value.can_respond)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(MessageAddCommentCard, {
                        onCommentAdded: _cache[1] || (_cache[1] = ($event: any) => (message.value = $event))
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (message.value && (message.value.can_respond || message.value.comments?.length))
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 1,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(MessageCommentsCard, {
                        comments: message.value.comments
                      }, null, 8, ["comments"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (message.value)
        ? (_openBlock(), _createBlock(_component_a_col, {
            key: 0,
            xs: 24,
            lg: 6
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_row, { gutter: [16,16] }, {
                default: _withCtx(() => [
                  (message.value)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 0,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, { title: "Details" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, {
                                gutter: [16,16],
                                class: "no-mb"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _hoisted_2,
                                      _hoisted_3,
                                      _createTextVNode(" " + _toDisplayString(message.value.project?.name || '-'), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _hoisted_4,
                                      _hoisted_5,
                                      _createTextVNode(" " + _toDisplayString(message.value.building?.number || '-'), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _hoisted_6,
                                      _hoisted_7,
                                      _createVNode(_component_a_tooltip, {
                                        title: new Date(message.value.created_at).toLocaleString('nl-NL'),
                                        placement: "right"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(message.value.created_ago), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["title"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _hoisted_8,
                                      _hoisted_9,
                                      _createTextVNode(" " + _toDisplayString(message.value.read_at ? 'Ja' : 'Nee'), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (message.value?.media?.length)
                    ? (_openBlock(), _createBlock(_component_a_col, {
                        key: 1,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card, {
                            title: 'Bijlages (' + message.value.media.length + ')'
                          }, {
                            default: _withCtx(() => [
                              _createVNode(MessageFilelist, {
                                media: message.value.media
                              }, null, 8, ["media"])
                            ]),
                            _: 1
                          }, 8, ["title"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})